// extracted by mini-css-extract-plugin
module.exports = {"main":"VideogameNoEncontrado_main__V-a4H","load":"VideogameNoEncontrado_load__3zZeu"};